<template>
	<div id="merchantDetail">
		<DetailCard :config="config"></DetailCard>

		<div class="gttcard" style="margin-bottom: 24px;">
			<!-- <p class='gttcard-tt'></p> -->
			<el-tabs v-model="activeName" @tab-click="tabClick">
				<el-tab-pane :label="$t('terminal.device_list')" name="equip"></el-tab-pane>
				<el-tab-pane :label="$t('merchant.branch_management')" name="bcstore"></el-tab-pane>
				<el-tab-pane :label="$t('terminal.broadcast_record')" name="record"></el-tab-pane>
			</el-tabs>
			<div v-if="activeName == 'equip'" class="gttcard-in">
				<div id="mcbindeq" class v-loading="loading">
					<el-row :gutter="20" class>
						<el-col :span="8">
							<el-button size="small" type="primary" icon @click="bindTer">{{ $t('terminal.binding_device') }}</el-button>
							<el-button size="small" type icon @click="batchBindEq">{{ $t('app_bind_all') }}</el-button>
							<el-button size="small" v-show="false" @click="batchUnbind" :disabled="sRows.length == 0"
								type="danger" plain>{{ $t('app_unbind_selected') }}</el-button>
						</el-col>
					</el-row>
					<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" :data="tableData"
						@selection-change="batchSelected" style="width: 100%">
						<el-table-column v-if="false" type="selection" width="55"></el-table-column>
						<el-table-column prop="deviceId" :label="$t('terminal.device_sn')" width></el-table-column>
						<el-table-column prop="deviceName" :label="$t('terminal.device_name')" width></el-table-column>
						<el-table-column prop="productName" :label="$t('terminal.device_model')" width></el-table-column>
						<el-table-column prop="branchName" :label="$t('merchant.store_name')" :formatter="setMech" width></el-table-column>
						<el-table-column prop="orderNum" :label="$t('merchant.message_num')"></el-table-column>
						<el-table-column prop="price" :label="$t('merchant.all_collection')" width></el-table-column>
						<el-table-column prop="createTime" :label="$t('app_update_time')" width="176"></el-table-column>
						<el-table-column :label="$t('app_operation')" width="102">
							<template slot-scope="scope">
								<el-button @click="editRow(scope.row)" type="text">{{ $t('app_edit') }}</el-button>
								<label class="opbline">|</label>
								<el-button @click="unbindRow(scope.row)" type="text" class="opdcolor">{{ $t('app_unbind') }}</el-button>
							</template>
						</el-table-column>
					</el-table>
					<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>
				</div>
			</div>
			<Store v-if="activeName == 'bcstore'"></Store>
			<ReceiptRec v-if="activeName == 'record'" :config="prconfig"></ReceiptRec>
		</div>

		<ImportEquip :config="ipconfig"></ImportEquip>

		<el-dialog @close="closeDiaBind" style="min-width: 1140px;" class="gstdia" :title="isEqEdit? $t('terminal.edit_device'): $t('terminal.binding_device')"
			:visible.sync="showBindDia">
			<el-form :model="bform" :rules="rulesBind" ref="ruleFormb">
				<el-form-item :label="$t('terminal.device_sn')" :label-width="$formlbWidth" prop="sn">
					<el-autocomplete :disabled="isEqEdit" style="width: 100%;" v-model="bform.sn" value-key="deviceid"
						:fetch-suggestions="querySearchAsync" :placeholder="$t('app_input')" @select="handleSelect"> 
					</el-autocomplete>
				</el-form-item>
				<el-form-item :label="$t('merchant.branch_number')" :label-width="$formlbWidth" prop>
					<Bstore :config="bconfig"></Bstore>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDiaBind">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="submitBind">{{ $t("app_bind") }}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog @close="closeDia" style="min-width: 1140px;" class="gstdia" :title="$t('merchant.edit_merchant')" :visible.sync="showEditDia">
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('merchant.store_name')" :label-width="$formlbWidth" prop="merchantName">
					<el-input v-model="tform.merchantName" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.merchant_name')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.contacts" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.merchant_tel')"  :label-width="$formlbWidth" prop>
					<el-input v-model="tform.merchantPhone" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.merchant_num')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.merchantNo" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.sub_organization')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.subMerchant" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.merchant_can_num')" :label-width="$formlbWidth" prop>
					<el-input v-model="tform.channelNo" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item vvif="$isAdminType()" :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop="agentId">
					<Merchant :config="editMc"></Merchant>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="submit">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">
      </div>-->
		</el-dialog>
	</div>
</template>

<style>
</style>

<script>
	import DetailCard from "@/components/DetailCard.vue";
	import Bstore from "@/components/Bstore.vue";
	import Pages from "@/components/Pages.vue";
	import EquipList from "@/components/EquipList.vue";
	import Merchant from "@/components/Merchant.vue";
	import Store from "@/views/bcstore/Store.vue";
	import ReceiptRec from "@/components/ReceiptRec.vue";
	import ImportEquip from "@/components/ImportEquip.vue";
	export default {
		data() {
			return {
				prconfig: "",
				activeName: "equip",
				detail: "",
				mcNo: "",
				config: {},
				pconfig: {},
				bconfig: {},
				page: 1,
				total: 0,
				showBindAg: false,
				showdia: false,
				loading: false,
				sRows: [],
				mcId: "",
				isEqEdit: false,
				tableData: [],
				showEditDia: false,
				showBindDia: false,
				eqs: [],
				queryWords: "",
				queryLock: false,
				ipconfig: {},
				bform: {
					sn: "",
					sid: ""
				},
				tform: {
					merchantId: "",
					merchantName: "",
					contacts: "",
					agentId: "",
					merchantPhone: "",
					merchantNo: "",
					subMerchant: "",
					channelNo: ""
				},
				rulesBind: {
					sn: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					sid: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}]
				},
				editMc: {},
				rules: {
					merchantId: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					merchantName: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					merchantPhone: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					merchant: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					contacts: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					merchantNo: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					subMerchant: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					channelNo: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}]
				}
			};
		},
		components: {
			DetailCard,
			Pages,
			EquipList,
			Merchant,
			Store,
			ReceiptRec,
			Bstore,
			ImportEquip
		},
		methods: {
			batchBindEq() {
				var _this = this;
				this.ipconfig = {
					type: 3, //// 0.equipement 1.agent 2.upgradedetail 3.merchant
					agid: "",
					showDia: true,
					callback: () => {
						_this.getList();
					}
				};
			},
			setMech(row) {
				return row.branchName == null ? row.merchantName : row.branchName;
			},
			querySearchAsync(queryString, cb) {
				var _this = this;
				this.queryWords = queryString;
				if (!this.queryLock) {
					this.queryLock = true;
					setTimeout(() => {
						var merchantId = this.mcId;
						/////////////////////////////////////
						// var words = _this.queryWords
						// var results = words ? _this.eqs.filter(this.createStateFilter(words)) : _this.eqs;
						// cb(results)
						// /////////////////////////////////////
						var query = _this.queryWords;
						query = query ? query : "??????"; ////??????
						_this.$mechGetEq(
							merchantId,
							query,
							res => {
								if (res.status == 200) {
									_this.eqs = res.data;
									var eqs = _this.eqs;
									var words = _this.queryWords;
									var results = words ?
										eqs.filter(this.createStateFilter(words)) :
										eqs;
									cb(results);
									_this.queryLock = false;
								}
							},
							""
						);
					}, 3000);
				}
			},
			createStateFilter(queryString) {
				return state => {
					return (
						state.deviceid.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			handleSelect(item) {
				// console.log(item);
			},
			tabClick() {
				var val = this.activeName;
				if (val == "record") {
					var _this = this;
					setTimeout(() => {
						_this.prconfig = {
							ctype: "1", ///// 0 eq 1 bcstore
							storeid: "",
							mcid: this.mcId
						};
					}, 9);
				}
			},
			setForm() {
				var data = this.detail;
				this.tform.merchantId = data.merchantId;
				this.tform.agentId = data.agentId;
				this.tform.merchantName = data.merchantName;
				this.tform.merchantPhone = data.merchantPhone;
				this.tform.contacts = data.contacts;
				this.tform.merchantNo = data.merchantNo;
				this.tform.subMerchant = data.subMerchant;
				this.tform.channelNo = data.channelNo;
				this.setMcCtr(data.agentId);
			},
			closeDia() {
				this.showEditDia = false;
				(this.tform.merchantId = ""),
				(this.tform.merchantName = ""),
				(this.tform.merchantPhone = "");
				//this.tform.merchant = ''
				this.tform.merchantNo = "";
				this.tform.subMerchant = "";
				this.tform.channelNo = "";
			},
			closeDiaBind() {
				this.showBindDia = false;
				this.isEqEdit = false;
				(this.bform.sn = ""), (this.bform.sid = "");
				var _this = this;
				this.bconfig = {
					mcid: this.mcId,
					callback: vl => {
						_this.bform.sid = vl;
					}
				};
			},
			submitBind() {
				this.$refs["ruleFormb"].validate(valid => {
					if (valid) {
						this.bindRqs();
					}
				});
			},
			// bbindRqs () {
			//    this.$editMerchant(this.tform.merchantId, this.tform.merchantName, this.tform.merchantPhone, this.tform.contacts, this.tform.agentId, this.tform.merchantNo, this.tform.subMerchant, this.tform.channelNo, res => {
			//      if (res.status == 200) {
			//         this.getDetail()
			//         this.closeDia()
			//      } else {
			//        this.$message.error(res.message)
			//      }
			//   }, '')
			//
			// },
			submit() {
				this.$refs["ruleForm"].validate(valid => {
					if (valid) {
						this.okDia();
					}
				});
			},
			okDia() {
				this.$editMerchant(
					this.tform.merchantId,
					this.tform.merchantName,
					this.tform.merchantPhone,
					this.tform.contacts,
					this.tform.agentId,
					this.tform.merchantNo,
					this.tform.subMerchant,
					this.tform.channelNo,
					res => {
						if (res.status == 200) {
							this.getDetail();
							this.closeDia();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			setMcCtr(vl) {
				var _this = this;
				this.editMc = {
					type: "1",
					size: "",
					vlkey: "agentId",
					value: vl ? vl : "",
					callback: vl => {
						_this.tform.agentId = vl;
					}
				};
			},
			bindTer() {
				var _this = this;
				this.bconfig = {
					mcid: this.mcId,
					callback: vl => {
						_this.bform.sid = vl;
					}
				};
				this.showBindDia = true;
			},
			bindRqs() {
				var fm = this.bform;

				if (this.isEqEdit) {
					this.$editBindEq(
						fm.sid ? fm.sid : "",
						fm.sn,
						this.mcId,
						res => {
							if (res.status == 200) {
								this.getList();
								this.getDetail();
								this.closeDiaBind();
								this.$message.success(res.message);
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
					return;
				}

				this.$bcstoreBindEq(
					this.mcNo,
					fm.sid ? fm.sid : "",
					fm.sn,
					res => {
						if (res.status == 200) {
							this.getList();
							this.getDetail();
							this.closeDiaBind();
							this.$message.success(res.message);
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			editRow(row) {
				this.isEqEdit = true;
				this.showBindDia = true;
				this.bform.sn = row.deviceId;
				this.bform.sid = ""; ///// branchId

				var _this = this;
				setTimeout(() => {
					_this.bconfig = {
						value: row.branchId ? row.branchId : "",
						mcid: _this.mcId,
						callback: vl => {
							_this.bform.sid = vl;
						}
					};
				}, 40);
			},
			unbindRow(row) {
				this.$showMsgBox(this.$t('terminal.sure_unbind_2'), () => {
					this.unbindRqs(row.deviceId, row.branchId);
				});
			},
			batchUnbind() {
				this.$showMsgBox(this.$t('terminal.sure_unbind_3'), () => {
					var ar = [];
					this.sRows.forEach(item => {
						ar.push(item.deviceId);
					});
					this.unbindRqs(ar.toString());
				});
			},
			unbindRqs(did, sid) {
				this.loading = true;
				var storeid = sid;
				this.$bcstoreUnbindEq(this.mcId, storeid, did, res => {
					this.loading = false;
					if (res.status == 200) {
						this.getList();
						this.getDetail();
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			batchSelected(val) {
				this.sRows = val;
			},
			getList() {
				this.loading = true;
				this.$merchBindEqList(
					this.page,
					this.$gRow,
					this.mcId,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			getDetail() {
				this.$merchDetail(
					this.mcId,
					res => {
						this.detail = res.data;
						this.setCard(res.data);
					},
					""
				);
			},
			setCard(data) {
				this.config = {
					title: this.$t('merchant.store_name') +  "：" + data.merchantName,
					rd1: [{
							tt: this.$t('merchant.merchant_id'),
							ct: data.merchantId
						},
						{
							tt: this.$t('terminal.app_contactPhone'),
							ct: data.merchantPhone
						},
						{
							tt: this.$t('terminal.bound_device_num'),
							ct: data.deviceNum
						},
						{
							tt: this.$t('merchant.merchant_num'),
							ct: data.merchantNo
						},
						{
							tt: this.$t('merchant.merchant_can_num'),
							ct: data.channelNo
						}
					],
					rd2: [{
							tt: this.$t('merchant.store_name'),
							ct: data.contacts
						},
						{
							tt: this.$t('terminal.app_distributor'),
							ct: data.agentName
						},
						{
							tt: this.$t('terminal.merchant_add_time'),
							ct: data.createTime
						},
						{
							tt: this.$t('terminal.sub_organization'),
							ct: data.subMerchant
						}
					],
					rd3: [{
							tt: this.$t('terminal.broad_num'),
							ct: data.logplayNum
						},
						{
							tt: "",
							ct: ""
						}
					],
					edit: () => {
						this.showEditDia = true;
						this.setForm();
					}
				};
			}
		},
		mounted() {
			this.mcId = this.$route.query.merchantId;
			this.mcNo = this.$route.query.mcno;
			this.getDetail();
			this.getList();
			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getList();
				}
			};
		}
	};
</script>
